"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceProvider = exports.InvoiceComponent = void 0;
var Invoice_1 = require("./Invoice");
Object.defineProperty(exports, "InvoiceComponent", { enumerable: true, get: function () { return Invoice_1.InvoiceComponent; } });
var InvoiceContext_1 = require("./context/InvoiceContext");
Object.defineProperty(exports, "InvoiceProvider", { enumerable: true, get: function () { return InvoiceContext_1.InvoiceProvider; } });
